var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHintIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FAQ Circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-9.53674e-07 7C-9.53674e-07 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 -9.53674e-07 3.13401 -9.53674e-07 7Z",
    fill: "#0008C3",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.499999 7C0.499999 10.5898 3.41015 13.5 7 13.5C10.5898 13.5 13.5 10.5898 13.5 7C13.5 3.41015 10.5898 0.5 7 0.5C3.41015 0.5 0.499999 3.41015 0.499999 7Z",
    stroke: "#0008C3",
    strokeOpacity: 0.25,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.61719 4.99714L8.41512 4.39095C7.99112 3.11895 6.31301 2.84663 5.50852 3.91927C5.03728 4.5476 5.07015 5.42003 5.58735 6.01112L6.14129 6.64419C6.57194 7.13636 6.80931 7.76812 6.80931 8.4221V8.6129",
    stroke: "#0008C3",
    strokeOpacity: 0.25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.2049 10.421C6.2049 10.7538 6.47471 11.0236 6.80753 11.0236C7.14035 11.0236 7.41016 10.7538 7.41016 10.421C7.41016 10.0882 7.14035 9.81836 6.80753 9.81836C6.47471 9.81836 6.2049 10.0882 6.2049 10.421Z",
    fill: "#0008C3",
    fillOpacity: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHintIcon);
export default __webpack_public_path__ + "static/media/hint_icon.15ae51d333e765cd79ed1021d26ddc1c.svg";
export { ForwardRef as ReactComponent };